import { QueryResult, useQuery } from '@apollo/client';
import GET_USAGE_INSIGHTS from '../api/getUsageInsights';
import type { UsageInsightsData, UsageRangeVariables } from '../types';

/**
 * RITA-1505 (Nutzungserfassung Phase 2c) — Kennzahlen der Auswertungsseite.
 *
 * CONTRACT (Entwurf B): fetchPolicy 'network-only', errorPolicy 'none',
 * notifyOnNetworkStatusChange true.
 * - 'network-only': die Seite beantwortet die Frage „wie wird das PRM gerade benutzt“; ein
 *   Zwischenspeicher aus einem früheren Zeitraum wäre eine falsche Antwort.
 * - 'none': alle Wurzelfelder der Lese-API sind non-null. Wirft ein Resolver, liefert GraphQL
 *   für das ganze Dokument data: null — mit 'all' stünde die Seite mit leeren Zahlen statt mit
 *   einem ehrlichen Fehlerzustand da.
 * - notifyOnNetworkStatusChange: ohne diese Option zeigt „Erneut versuchen“ keinen Ladezustand.
 *   Der Knopf ruft `refetch().catch(() => undefined)`: bei errorPolicy 'none' lehnt die Zusage
 *   im Fehlerfall ab, und eine unbehandelte Ablehnung würde die Fehlererfassung auslösen.
 *   Die Seite unterscheidet damit ein NACHLADEN (refetch mit gehaltener Antwort, kein Gerüst,
 *   Abschnitte bleiben montiert) vom ersten Laden, vom Zeitraumwechsel und vom Neuversuch nach
 *   einem Fehler (NutzungPage.tsx, KI-Review !748).
 *
 * Jeder Zeitraumwechsel erzeugt damit bewusst eine neue Anfrage und eine weitere Audit-Zeile
 * (sensibler Read) — dokumentiert in docs/DOMAIN.md.
 */
export const useUsageInsights = (days: number): QueryResult<UsageInsightsData, UsageRangeVariables> =>
  useQuery<UsageInsightsData, UsageRangeVariables>(GET_USAGE_INSIGHTS, {
    variables: { range: { days } },
    fetchPolicy: 'network-only',
    errorPolicy: 'none',
    notifyOnNetworkStatusChange: true,
  });

export default useUsageInsights;
